<template>
  <div class="aird-digitalscroll" :style="{ height: fontSize + 'px', lineHeight: fontSize + 'px' }">
    <p
      v-for="(item, index) in computeNumber"
      :key="index"
      class="aird-digitalscroll__item"
      :style="{ width: fontSize / 2 + 3 + 'px', fontSize: fontSize + 'px' }"
    >
      <span ref="numberDom" :style="{ color: color, letterSpacing: fontSize + 'px' }"
        >0123456789</span
      >
    </p>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class NumberScroll extends Vue {
  @Prop({ type: Number, default: 0 }) number;
  @Prop({ type: String, default: '#FFF' }) color;
  @Prop({ type: String | Number, default: 20 }) fontSize;

  maxLen = 10;
  computeNumber = [];

  @Watch('number')
  changeNumber() {
    this.refresh();
  }

  mounted() {
    this.refresh();
  }

  prefixZero(num, n) {
    return (Array(n).join('') + num).slice(-n).split('');
  }
  // 设置每一位数字的偏移
  setNumberTransform() {
    const numberItems = this.$refs.numberDom;
    if (!numberItems) return;
    for (let index = 0; index < numberItems.length; index++) {
      const elem = numberItems[index];
      elem.style.transform = `translate(-50%,-${Number(this.computeNumber[index]) * 10}%`;
    }
  }
  // 定时刷新数据
  refresh() {
    this.computeNumber = this.prefixZero(this.number, this.maxLen);
    this.$nextTick(() => this.setNumberTransform());
  }
}
</script>

<style scoped>
.aird-digitalscroll {
  @apply flex justify-center h-full;
  line-height: 100%;
}

.aird-digitalscroll p {
  position: relative;
  display: inline-block;
  width: 12px;
  height: 100%;
  overflow: hidden;
  font-size: 20px;
  line-height: 100%;
  text-align: center;
  writing-mode: vertical-lr;
  text-orientation: upright;
}
.aird-digitalscroll p:last-child {
  margin-right: 0;
}

.aird-digitalscroll p span {
  position: absolute;
  top: 0;
  left: 50%;
  letter-spacing: 10px;
  transform: translate(-50%, -50%);
  transition: transform 1s ease;
}
</style>
